module.exports = __webpack_public_path__ + "img/oblak.2f75bfca.svg";